import { Heading } from '@/components/ui/catalyst/heading';
import { Text } from '@/components/ui/catalyst/text';
import type { TreatmentRecordRequestSchema } from '@/services/api/generated/treatmentRecordRequestsService';
import type { MedicalProvider } from '@/services/types/treatment-types';

import { RequestCardActivityLog } from './RequestCardActivityLog';

interface ActivityLogTabProps {
  request: TreatmentRecordRequestSchema;
  provider: MedicalProvider;
}

export const ActivityLogTab = ({ request, provider }: ActivityLogTabProps) => {
  return (
    <div className="h-full flex flex-col">
      {/* Header */}
      <div className="px-6 py-4 border-b border-zinc-200">
        <Heading level={2}>Activity Log</Heading>
        <Text className="mt-1 text-zinc-500">
          Timeline of all actions and updates for this request
        </Text>
      </div>

      {/* Activity Log Content */}
      <div className="flex-1 overflow-auto px-6 py-6">
        <div className="rounded-lg border border-zinc-200 bg-white p-6">
          <RequestCardActivityLog request={request} provider={provider} />
        </div>
      </div>
    </div>
  );
};
